import { RegionDistanceTable } from "./RegionDistanceTable";
import { Process } from "../../../lib/Process";
import { Region } from "./Region";
import { observe } from "../../../lib/reactive";
import { FakeLodash } from "../../../lib/coreutil/FakeLodash";
export class RegionChainDistanceTable {
    constructor(data) {
        this.data = data;
        let offset = 0;
        const regions = [];
        while (offset < data.length) {
            const region = new RegionDistanceTable(data, offset);
            regions.push(region);
            offset += region.byte_size;
        }
        this.tables = regions;
    }
}
(function (RegionChainDistanceTable) {
    let Description;
    (function (Description) {
        function bytesize(desc) {
            return FakeLodash.sumBy(desc.regions, r => RegionDistanceTable.Description.byteSize(new Region.Indexing(r)));
        }
        Description.bytesize = bytesize;
    })(Description = RegionChainDistanceTable.Description || (RegionChainDistanceTable.Description = {}));
    class Generator extends Process {
        constructor(description) {
            super();
            this.description = description;
            this.active_generator = null;
            this.solved_nodes = 0;
            this.progress = observe({
                generator: this,
                visited_nodes: 0,
                active_region: 0,
                sub_progress: this.description.regions.map(r => ({
                    region: new Region.Indexing(r),
                    depth: 0,
                    nodes: 0
                }))
            });
            this.subgenerators = this.description.regions.map((region, i) => {
                return new RegionDistanceTable.Generator({
                    multitile: this.description.multitile,
                    region: region
                })
                    .onProgress(progress => {
                    this.progress.update2(c => {
                        c.visited_nodes = this.solved_nodes + c.visited_nodes;
                        c.active_region = i;
                        c.sub_progress[i] = progress;
                    });
                });
            });
            this.withInterrupt(100, 1);
        }
        stop() {
            super.stop();
            this.active_generator?.stop();
        }
        async implementation() {
            const generated_regions = [];
            for (let i = 0; i < this.description.regions.length; i++) {
                if (this.should_stop)
                    return null;
                const generator = this.active_generator = this.subgenerators[i];
                generated_regions.push(await generator.run());
                console.log(`Generator ${i} ended`);
                this.solved_nodes += generator.region.size;
            }
            const sum = FakeLodash.sumBy(generated_regions, r => r.byte_size);
            const total = new Uint8Array(sum);
            let offset = 0;
            for (let region of generated_regions) {
                total.set(region.underlying_data, offset);
                offset += region.byte_size;
            }
            const result = new RegionChainDistanceTable(total);
            this.progress.update2(c => {
                c.final_result = result;
            });
            return result;
        }
        onProgress(f) {
            this.progress.subscribe(f);
            return this;
        }
    }
    RegionChainDistanceTable.Generator = Generator;
})(RegionChainDistanceTable || (RegionChainDistanceTable = {}));
